var map = {
	"./DSC_0166.jpg": 5480,
	"./DSC_0196.jpg": 6494,
	"./DSC_0197.jpg": 6334,
	"./DSC_0224.jpg": 889,
	"./DSC_0226.jpg": 2128,
	"./DSC_0942-1024x683.jpg": 4775,
	"./IMG_1965-1024x768.jpg": 9319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;